// extracted by mini-css-extract-plugin
module.exports = {"root":"StepsBanner_root__22VMx","title":"StepsBanner_title__5SrA9","icon":"StepsBanner_icon__2qN6u","step":"StepsBanner_step__3Mu0r","stepTitle":"StepsBanner_stepTitle__12teF"};